<template>
  <component :is="tag" :class="componentClasses">
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  tag: {
    type: String,
    default: 'h3',
  },
  size: {
    type: String,
    default: '6',
  },
  resize: {
    type: String,
  },
});

const componentClasses = computed(() => [
  'stk-title',
  props.size && !props.resize ? `stk-size-${props.size}` : '',
  props.resize ? `stk-resize-${props.resize}` : '',
]);
</script>


<style>
.stk-title {
  color: var(--stk-text-strong);
  font-weight: 600;
  line-height: 1.125;
}
</style>
